import React from 'react';
import injectSheet from 'react-jss';
import Img from 'gatsby-image';

import BackgroundImageSection from '../components/BackgroundImageSection';
import Section from '../components/Section';
import Link from '../components/Link';
import ImageSnippet from '../components/ImageSnippet';
import Divider from '../components/Divider';

const maxWidth = '73.85rem';

const styles = {
    buttonRect: {
        width: '21em',
        height: '3.67em',
        border: 'none',
        backgroundColor: '#43AAFF'
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: '1.06rem',
        '& h4': {
            textAlign: 'center'
        },
        '& p': {
            width: '78%',
            textAlign: 'center',
            lineHeight: 1.3
        }
    },
    diagram: {
        width: '100%',
        margin: '5rem 0 10rem 0'
    },
    sectionFeatures: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    contacts: {
        display: 'flex',
        flexWrqp: 'wrap',
        justifyContent: 'center',
        margin: '2rem 0'
    }
};

export default injectSheet(styles)(({ classes, data }) => {
    const sectionTop = (
        <BackgroundImageSection
            taller={true}
            maxWidth={maxWidth}
            sizesBackground={data.imageBackground.childImageSharp.sizes}
            justifyContent='center'>
            <h1>{data.contents.home.title}</h1>
            <p>{data.contents.home.description}</p>
            <Link to="/downloads">
                <button className={classes.buttonRect} type="button">
                    {data.contents.home.download}
                </button>
            </Link>
        </BackgroundImageSection>
    );
    
    const features = data.contents.home.feature.map((feature, index) => {
        let sizes;
        data.imageFeatures.edges.some((edge, index) => {
            if (edge.node.name === feature.name) {
                sizes = edge.node.childImageSharp.sizes;
                return true;
            }
            return false;
        });

        return sizes ? (
            <ImageSnippet key={index}>
                <Img style={{ width: '6.47rem' }}sizes={sizes} />
                <h1>{feature.header}</h1>
                <p>{feature.description}</p>
            </ImageSnippet>
        ) : null;
    });

    const sectionFeatures = (
        <Section className={classes.sectionFeatures} maxWidth={maxWidth}>
            {features}
        </Section>
    );

    const sectionHowWorks = (
        <Section className={classes.section} maxWidth={maxWidth}>
            <h4>{data.contents.home.howworks.header}</h4>
            <p>{data.contents.home.howworks.description}</p>
            <Img
                outerWrapperClassName={classes.diagram}
                sizes={data.imageHowWorks.childImageSharp.sizes}
                />
        </Section>
    );

    const sectionMoving = (
        <BackgroundImageSection
            taller={true}
            maxWidth={maxWidth}
            sizesBackground={data.imageMoving.childImageSharp.sizes}
            justifyContent='center'
            boxShadow='none'>
            <h1>{data.contents.home.moving.header}</h1>
            <p>{data.contents.home.moving.description}</p>
            <Link to="/usecase">
                <button className={classes.buttonRect} type="button">
                    {data.contents.home.moving.usecase}
                </button>
            </Link>
        </BackgroundImageSection>
    );

    const contacts = [{
        name: "contact@onairvr.io",
        to: "mailto:contact@onairvr.io",
        sizes: data.imageContactMail.childImageSharp.sizes
    }, {
        name: "www.clicked.co.kr",
        to: "http://clicked.co.kr",
        sizes: data.imageContactSite.childImageSharp.sizes
    }].map((contact, index) => {
        return (
            <ImageSnippet key={index} width='12.4rem' height='12rem'>
                <Link to={contact.to}>
                    <Img sizes={contact.sizes} />
                    <p>{contact.name}</p>
                </Link>
            </ImageSnippet>
        );
    });

    const sectionContact = (
        <Section className={classes.section} maxWidth={maxWidth}>
            <h4>{data.contents.home.contact.header}</h4>
            <p>{data.contents.home.contact.description}</p>
            <div className={classes.contacts}>
                {contacts}
            </div>
        </Section>
    );
    
    return (
        <div>
            {sectionTop}
            {sectionFeatures}
            <Divider maxWidth={maxWidth} />
            {sectionHowWorks}
            {sectionMoving}
            {sectionContact}
        </div>
    );
});

export const query = graphql`
    query IndexHomeQuery {
        ...IndexLayoutFragment
        ...IndexHomeFragment
    }

    fragment IndexHomeFragment on RootQueryType {
        imageBackground: file(relativePath: { eq: "bg_home.jpg" }) {
            childImageSharp {
                sizes(maxWidth: 2000, quality: 90) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        imageFeatures: allFile(filter: {relativeDirectory: { eq: "features" } }) {
            edges {
                node {
                    name
                    childImageSharp {
                        sizes(maxWidth: 110) {
                            ...GatsbyImageSharpSizes
                        }
                    }
                }
            }
        }

        imageHowWorks: file(relativePath: { eq: "howworks.png" }) {
            childImageSharp {
                sizes(maxWidth: 2000) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        imageMoving: file(relativePath: { eq: "bg_moving.jpg" }) {
            childImageSharp {
                sizes(maxWidth:2000) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        imageContactMail: file(relativePath: { eq: "contact_mail.png" }) {
            childImageSharp {
                sizes(maxWidth: 150) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        imageContactSite: file(relativePath: { eq: "contact_site.png" }) {
            childImageSharp {
                sizes(maxWidth: 150) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        contents: stringsToml {
            home {
                title
                description
                download
                feature {
                    name
                    header
                    description
                }
                howworks {
                    header
                    description
                }
                moving {
                    header
                    description
                    usecase
                }
                contact {
                    header
                    description
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js